<template>
<div>
     <vs-dialog prevent-close v-model="active" class="domicializar" @close="reseteo" width="700px">
        <template #header>
          <h4 class="not-margin">
           Pagos
          </h4>
        </template>
        <div class="con-form">
          <!-- <p v-if="cuentaGuardada == ''">¿Estas seguro de generar intención de pago?
          </p> -->
          <div class="con-content">
            <div v-if="showAmbos">
              <h5 class="text-center">Selecciona un método de pago</h5>
              <div class="center">
              <vs-row class="mt-4 justify-content-center">
                <!-- <vs-col class="d-flex"> -->
                  <!-- <p v-if="pagoEnLinea == false && [13].includes(this.institucion)">Favor de ponerse en contacto con la institución para concer las formas de pago.</p> -->

                  <!-- <div class="mx-auto" v-if="showDomiciliarBoton && cuentaGuardada[0]">
                    <vs-button
                      class="mx-1"
                      @click="getShow('domiciliar')"
                    >
                        Domiciliación
                    </vs-button>
                  </div> -->
                <!-- </vs-col> -->
                <vs-col sm="12" lg="8" class="mt-3 text-center"  v-if="showIntension && ![28, 18].includes(institucion)">
                  <h6 class="mt-3 text-secondary">
                    Pagos referenciados
                  </h6>
                  <hr>
                </vs-col>
                <vs-col sm="12" lg="8" class="mt-3" v-if="showIntension && ![28].includes(institucion)">
                  <div class="mx-auto">
                    <vs-button
                      class="mx-1"
                      block
                      size="xl"
                      @click="getGenerarIntension(rows), getShow('intencion')"
                    >
                      Generar referencia Banamex
                    </vs-button>
                    <div class="text-center">
                      Desarrollado por 
                      <img src="https://upload.wikimedia.org/wikipedia/commons/9/92/Citibanamex_logo.svg" alt="Banamex" width="100px">
                    </div>
                  </div>
                </vs-col>
                <vs-col sm="12" lg="8" class="mt-3" v-if="showIntension && ([6, 28].includes(institucion))">
                  <div class="mx-auto">
                    <vs-button
                      class="mx-1"
                      danger
                      block
                      size="xl"
                      @click="getGenerarReferenciaSantander(rows), getShow('intencion')"
                    >
                      Generar referencia Santander
                    </vs-button>
                    <div class="text-center">
                      Desarrollado por 
                      <img src="https://upload.wikimedia.org/wikipedia/commons/b/b8/Banco_Santander_Logotipo.svg" alt="Santander" width="100px">
                    </div>
                  </div>
                </vs-col>
                <vs-col sm="12" lg="8" class="mt-3" v-if="showWire4Button">
                  <div class="mx-auto">
                    <vs-button
                      :loading = "loadingSpinner"
                      class="mx-1"
                      block
                      size="xl"
                      success
                      @click="wire4Checkout()"
                    >
                      Transferencia SPEI
                    </vs-button>
                  </div>
                  <div class="text-center">
                      Desarrollado por 
                      <img src="/img/monex-logo.png" alt="Monex logo" width="60px">
                    </div>
                </vs-col>
                <vs-col sm="12" lg="8" class="mt-3 text-center">
                  <h6 class="mt-3 text-secondary">
                    Pagos en línea
                  </h6>
                  <hr>
                </vs-col>
                <vs-col sm="12" lg="8" class="mt-3" >
                  <div class="mx-auto" v-if="pagoEnLinea">
                    <vs-button
                      class="mx-1"
                      danger
                      block
                      size="xl"
                      @click="getReferencia(rows)"
                    >
                      Paga en línea con VISA o Mastercard, ya sea con 
                      tarjeta de débito o crédito, en una sola exhibición.
                    </vs-button>
                    <div class="text-center">
                      Desarrollado por 
                      <img src="https://upload.wikimedia.org/wikipedia/commons/b/b8/Banco_Santander_Logotipo.svg" alt="Santander" width="100px">
                    </div>
                  </div>
                  <hr>
                </vs-col>
                <vs-col sm="12" lg="8" class="my-3">
                  <div class="mx-auto">
                    <div id="paypal-button-container"></div>
                    <p class="text-danger text-center mt-3" id="result-message"></p>
                    <p class="text-center text-muted mt-3">{{ onlinePaymentsMsg }}</p>
                  </div>
                </vs-col>
              </vs-row>
              <div class="mt-3" v-if="pagoEnLinea">
                  <div>
                    <p class="mb-0"><small><strong>PAGOS ACEPTADOS PERO QUE NO SE REFLEJAN EN SU ESTADO DE CUENTA</strong></small></p> 
                    <p class="mb-0"><small>Comunicarse a la administración local de su colegio o escribir a los siguientes correos</small></p>
                    <p class="mb-0"><small>{{info_contacto.nombre}}</small></p>
                    <p class="mb-0"><small>Dirección: {{info_contacto.formato_domicilio}}</small></p>
                    <p class="mb-0" v-if="info_contacto.correo_administracion"><small>Correo: {{info_contacto.correo_administracion}}</small></p>
                  </div>
                  <div class="mb-3">
                      <small><a target="_blank" download="Aviso de privacidad" 
                          href="https://sigem.maristas.mx/legal/Maristas._Aviso_de_Privacidad_AEMC.pdf">
                          Aviso de privacidad
                      </a></small>
                  </div>
              </div>
            </div>
          <div>
          <vs-row v-if="showDomiciliar">
            <vs-col sm="12" lg="6">
              <div v-for="concepto in rows" :key="concepto.id">
                <p class="mb-0">Concepto: <strong>{{concepto.concepto}}</strong></p>
                <p class="mb-0">Fuente: <strong>{{concepto.fuente}}</strong></p>
                <md-chip v-if="concepto && concepto.comentarios !== 'Cargo cancelado'" class="mb-1 fontMedium" :class="'mini-chip ' + getColor(getVencidoValue(concepto))" ><strong> {{ getVencidoValue(concepto) }} </strong></md-chip>
                <p class="salto mb-1"><strong> F.Vencimiento:</strong> <i class="far fa-calendar-check"></i> {{ concepto && concepto.fecha_vencimiento ? concepto.fecha_vencimiento : 'No definido'}}</p>
                <div v-for="(value, key) in concepto.descuentos" :key="key+i" :val="value.id" style="display: flex; align-items: center;">
                    <div>
                        <p class="mb-0" style="color: #ffbc34; font-size: 22px"><i class="fas fa-check-circle"></i></p>
                    </div>
                    <div class="pl-2">
                        <p class="mb-0">
                            {{ value.descripcion + ' valido antes de ' + value.fecha + ' por ' + formatoDescuentos(value)}} 
                        </p>
                    </div>
                </div>
                <p>Monto: <strong>{{concepto.monto | currency}}</strong></p>
                
                <md-chip v-if="concepto.parcializado == true && concepto.saldo === 0 && concepto.fuente === 'Parcializacion de cargos libre'" :class="'mini-chip ' + getColor('Cargo parcializado')" ><strong> Pago por parcialización</strong></md-chip>
                <md-chip v-else :class="'mini-chip ' + getColor(getStatusCargo(concepto))" ><strong>{{   getStatusCargo(concepto) }}</strong></md-chip>
                <p class="salto mb-0"></p>
                <p class="salto mb-0" v-if="concepto.saldo > 0 ">Saldo pendiente por cobrar</p>
                <p class="salto mb-0 fontBig" v-if="concepto.saldo != 0 ">{{ concepto.saldo != 0 ? concepto.saldo : 0 | currency}}</p>
                <p class="mb-0">Estatus de saldo: <strong>{{concepto.saldo | currency}}</strong></p>
                <md-divider class="my-3" v-if="rows.length > 1"></md-divider>
              </div>
            </vs-col>
            <vs-col sm="12" lg="6">
              <vs-select
                  v-model="cuenta"
                  @input="getInfo(cuenta)"
              >
                  <vs-option
                      v-for="opcion in cuentaGuardada"
                      :key="opcion.id" 
                      :label="opcion.cuenta" :value="opcion.id">
                          {{opcion.cuenta}}
                  </vs-option>
              </vs-select>
              <div v-if="cuenta !== ''">
                <p class="mb-0">Tarjetahabiente: <strong>{{infoCuenta.nombre}}</strong></p>
                <p class="mb-0">Banco: <strong>{{infoCuenta.banco}}</strong></p>
                <p class="mb-0">Tipo: <strong>{{infoCuenta.tipo}}</strong></p>
                <p class="mb-0">Cuenta: <strong>{{infoCuenta.cuenta}}</strong></p>
              </div>
            </vs-col>
          </vs-row>
          <vs-button
              v-if="showDomiciliar"
              class="ml-auto"
              :disabled="cuenta === ''"
              @click="getGuardarSeleccionada(rows)"
          >
              Guardar
          </vs-button>
          </div>
        </div>
        </div>
        </div>
      </vs-dialog>
      <pago-declinado v-model="activeModalMensaje"></pago-declinado>
</div>
</template>

<script>
import cobranza from '../../../../api/requests/cobranza-persona.js'
import domicializacion from '../../../../api/requests/domicializacion.js'
import declinado from './declinado.vue'
import PagoDeclinado from './pago_declinado.vue'
import { loadScript } from '@paypal/paypal-js';
export default {
    props:[
      'value',
      'rows',
      'personaId',
      'cicloEscolar',
      'institucion',
      'nivel',
      'nivelId',
      'listNivel',
      'programa',
      'programaId',
      'listPrograma',
      'permisos',
      'cuentaGuardada',
      'general',
      'personaRol',
      'pagar_paypal'
    ],
    data () {
        return {
            active: false,
            fecha: null,
            errorFields: [],
            infoCuenta: [],
            cuenta: '',
            typeCargo: [],
            domiciliar: '',
            generar: '',
            linea: '',
            seleccionCargos: [],
            seleccionDomiciliar: [],
            seleccionSantander: [],
            statusColores: {
                "Vencido" : "red",
                "En tiempo": "yellow",
                "Cargo por demanda" : "blue",
                "Aplicada" : "green",
                "Pagado totalmente": "green",
                "Sin aplicar" : "red",
                "Sin pagar" : "red",
                "Sin definir" : "none",
                "Pagado parcialmente": "yellow",
                "No obligatorio": "blue"
            },
            showAmbos: true,
            showDomiciliarBoton: true,
            showDomiciliar: false,
            showIntension: true,
            pagoEnLinea: false,
            cargandoSantander: '',
            activeModalMensaje:false,
            info_contacto: {},
            permisosGenerales: [],
            bloquearPago: false,
            onlinePaymentsMsg: 'Puedes realizar el pago con tarjeta de débito o crédito en una sola exhibición.',
            showWire4Button: false,
            loadingSpinner: false,
        }
    },
    components:{
      PagoDeclinado
    },
    // created(){
      // this.getCuentaGuardad()
    // },
    methods: {
      async setLoaded(){
        let paramsReferencia = {           
          "persona" :this.personaId,
          "ciclo_escolar": this.cicloEscolar,
          "institucion": this.institucion,
          "cargos" : this.rows
        }

        const saldo = this.rows.reduce((total, obj) => total + obj.monto, 0);
        const matricula = this.general?.datos?.matricula;

        const buttonsParams = {
          saldo,
          matricula,
          paramsReferencia
        };

        // Cargar botones si se cuenta con credenciales para pago via PayPal
        await this.loadPaypalButtons(buttonsParams);

        await this.loadWire4Button(buttonsParams);
      },
      reseteo(){
        this.showAmbos = true,
        this.showDomiciliarBoton = true,
        this.showDomiciliar = false,
        this.showIntension = true
      },
      getShow(tipo){
        if(tipo === 'intension'){
          this.showDomiciliar = false
          this.showDomiciliarBoton = false
          this.showIntension = true

        }
        if(tipo === 'domiciliar'){
          this.showDomiciliar = true
          this.showDomiciliarBoton = true
          this.showAmbos = false
        }
      },
      async getDatosContacto(){
        const {data: response} = await cobranza.getDatosContacto(this.institucion)
        this.info_contacto = response
      },
      async getReferencia(info){
        try{
          let params = {           
            "persona" :this.personaId,
            "ciclo_escolar": this.cicloEscolar,
            "institucion": this.institucion,
            "cargos" : info
          }
          const response = await cobranza.getReferencia(params)
          this.getRespuestaSigem(response.data)
          this.loadingSantander('cargando')
          this.getSantander(response.data, info)
        }catch(error){
            this.$vs.notification({
              icon: '<i class="fas fa-exclamation-circle"></i>',
              sticky: true,
              width: '100%',
              duration: 'none',
              color: 'danger',
              position: null,
              title: error.data.message
            })
            this.loadingSantander('finalizado')
        }
      },
      loadingSantander(tipo){
        const vue = this
        
        if(tipo == 'cargando'){
          vue.cargandoSantander = this.$vs.loading({
            text: 'Su pago está siendo procesado por Santander. Le pedimos que mantenga esta ventana abierta hasta que el pago se confirme y se refleje en su pantalla.',
            type: 'points',
            color: '#000000',
            background: '#ffffff',
            opacity: 1
          })
        }
        if(tipo == 'finalizado'){
          vue.cargandoSantander.close()
            this.$emit('refreshTable')
        }
        if(tipo == 'declinado'){
          vue.cargandoSantander.close()
        }
      },
      async getRespuestaSigem(info, pago){
        try{
          const formData = new FormData()
          formData.append('referencia', info.referencia)
          const {data: response} = await cobranza.getRespuestaSigem(formData)
          if(response.status == 'no_conciliada'){
            setTimeout(() => {
              this.getRespuestaSigem(info)
            }, 5000)
          }else if(response.status == 'conciliada'){
            this.loadingSantander('finalizado')
            this.active = false
            this.$vs.notification({
              icon: '<i class="fas fa-check"></i>',
              sticky: true,
              duration: 'none',
              color: 'success',
              position: null,
              title: response.message
            })
            location.reload();
          }else if(response.status == 'pago_declinado'){
            this.loadingSantander('declinado')
            this.$vs.notification({
              icon: '<i class="far fa-times-circle"></i>',
              width: '100%',
              sticky: true,
              duration: 'none',
              position: null,
              title: response.message,
              text: 'Ingrese otro método de pago',
              content: declinado
            })
            this.activeModalMensaje =  true
          }
        }catch(error){
            this.$vs.notification({
              icon: '<i class="fas fa-exclamation-circle"></i>',
              width: '100%',
              sticky: true,
              duration: 'none',
              color: 'danger',
              position: null,
              title: error.data.message
            })
            this.loadingSantander('finalizado')
        }
      },
      async getSantander(info, pago){
          let params = {
            "amount": info.saldo,
            "id_branch": "01SNBXBRNCH",
            "reference": info.referencia,
            "institucion_id": this.institucion
          }
          const response = await cobranza.getSantander(params)
          window.open(response.data.url, "Pago", "width=800, height=700")
      },
      getTypeCargo(){
        if(this.rows != ''){
          let result = []
          this.rows.forEach(i => {
            result.push('')
          })
          this.typeCargo = result
        }
      },
      getSeleccionCargo(){
        if(this.rows != ''){
          let result = []
          this.rows.forEach(i => {
            result.push('')
          })
          this.seleccionCargos = result
        }
      },
      getSeleccionDomiciliar(){
        if(this.rows != ''){
          let result = []
          this.rows.forEach(i => {
            result.push('')
          })
          this.seleccionDomiciliar = result
        }
      },
      getSeleccionDomiciliar(){
        if(this.rows != ''){
          let result = []
          this.rows.forEach(i => {
            result.push('')
          })
          this.seleccionSantander = result
        }
      },
      // getCuenta (){
      //   if(this.rows != ''){
      //     let result = []
      //     this.rows.forEach(i => {
      //       result.push('')
      //     })
      //     this.cuenta = result
      //   }
      // },
      // getInfoCuenta (){
      //     let result = []
      //     this.rows.forEach(i => {
      //       result.push('')
      //     })
      //     this.infoCuenta = result
      // },
      // getFila(info, i){
      //   if(this.typeCargo[i] === 'domiciliar'){
      //       this.seleccionDomiciliar[i] = info
      //       this.seleccionCargos[i] = ''
      //   }
      //   if(this.typeCargo[i] === 'intencion'){
      //       this.seleccionCargos[i] = info
      //       this.seleccionDomiciliar[i] = ''
      //       this.cuenta[i] = ''
      //       this.infoCuenta[i] = ''
      //   }
      //   if(this.typeCargo[i] === 'linea'){
      //       this.seleccionSantander[i] = info
      //       this.seleccionCargos[i] = ''
      //       this.seleccionDomiciliar[i] = ''
      //   }
      //   let dom = 0
      //   let gen = 0
      //   let san = 0
      //   this.typeCargo.forEach(i => {
      //     if (i === 'domiciliar'){
      //       dom++
      //     }
      //     if (i === 'intencion'){
      //       gen++
      //     }
      //     if (i === 'linea'){
      //       san++
      //     }
      //   })
      //   if(dom > 0){
      //     this.domiciliar = true
      //   }
      //   else {
      //     this.domiciliar = false
      //   }
      //   if(gen > 0){
      //     this.generar = true
      //   }
      //   else {
      //     this.generar = false
      //   }
      //   if(san > 0){
      //     this.linea = true
      //   }else {
      //     this.linea = false
      //   }
      // },
      async getCuentaGuardad() {
          try {
              const response = await domicializacion.getCuentaGuardad(this.personaId)
              this.cuentaGuardada = response.data.cuentas_bancarias
              // this.infoCuenta = this.infoCuenta(response.data.cuentas_bancarias)
          } catch (error) {

          }
      },
        getInfo(indice){
            this.cuentaGuardada.forEach(i => {
                if(this.cuenta === i.id){
                    this.infoCuenta = {
                        "nombre": i.tarjetahabiente,
                        "cuenta": i.cuenta,
                        "banco": i.banco,
                        "tipo": i.tipo,
                        "id": i.id
                    }
                }
            })
        },
      async getAccion () {
          if (this.rows.length){
            let params = {           
              "persona" :this.personaId,
              "ciclo_escolar": this.cicloEscolar,
              "institucion": this.institucion,
              // "programa": this.programa,
              // "nivel_academico":this.nivel,
              "cargos" : this.rows
            }
              try {
                  const { data: response = null } = await cobranza.postPagar(params) || {}
                  if(response){
                      cobranza.vistaIntencion(response) || {}
                      // window.open(res.responseURL)
                      this.active = false
                      this.$emit('refreshTable')
                  }

              } catch (error) {
                if (error && error.response && error.response.data  && error.response.data.descripcion ){
                  this.$vs.notification({
                      progress: 'auto',
                      color: 'danger',
                      position: null,
                      title: 'Error',
                      text: error.response.data.descripcion
                  })
                }
              }
          }
      },
      async getGenerarIntension (info) {
          if (this.rows.length){
            this.showDomiciliarBoton = false
            let params = {           
              "persona" :this.personaId,
              "ciclo_escolar": this.cicloEscolar,
              "institucion": this.institucion,
              "cargos" : info
            }
              try {
                  const { data: response = null } = await cobranza.postPagar(params) || {}
                  if(response){
                      cobranza.vistaIntencion(response) || {}
                      this.seleccionCargos = []
                      this.$emit('refreshTable')
                  }

              } catch (error) {
                if (error && error.response && error.response.data  && error.response.data.descripcion ){
                  this.$vs.notification({
                      progress: 'auto',
                      color: 'danger',
                      position: null,
                      title: 'Error',
                      text: error.response.data.descripcion
                  })
                }
              }
          }
      },
      async getGenerarReferenciaSantander (info) {
          if (this.rows.length){
            this.showDomiciliarBoton = false
            let params = {           
              "persona" :this.personaId,
              "ciclo_escolar": this.cicloEscolar,
              "institucion": this.institucion,
              "cargos" : info
            }
              try {
                  const { data: response = null } = await cobranza.postPagarSantander(params) || {}
                  if(response){
                      cobranza.vistaIntencionSantander(response) || {}
                      this.seleccionCargos = []
                      this.$emit('refreshTable')
                  }

              } catch (error) {
                if (error && error.response && error.response.data  && error.response.data.descripcion ){
                  this.$vs.notification({
                      progress: 'auto',
                      color: 'danger',
                      position: null,
                      title: 'Error',
                      text: error.response.data.descripcion
                  })
                }
              }
          }
      },
      async getGuardarSeleccionada(info){
            const loading = this.$vs.loading()
            try {
              let domiciliar = []
                for(var x = 0;x < info.length; x++){
                    var obj = {
                      id : this.personaId,
                      ciclo_escolar: this.cicloEscolar,
                      institucion: this.institucion,
                      programa: this.programa,
                      cargo : info[x].id,
                      cuenta : this.infoCuenta.id
                    }
                    domiciliar.push(obj)
                }
                let solicitudes = domiciliar
                const response = await domicializacion.getGuardarSeleccionada(solicitudes)
                
                this.$emit('refreshTable')
                loading.close()
                var xhr = new XMLHttpRequest();
                xhr.open('GET', `/api/v1/domiciliacion/solicitud/${response.data.data}/descargar`, true);
                xhr.responseType = 'blob';

                xhr.onload = function(e) {
                if (this.status == 200) {
                    var blob = new Blob([this.response], {type: 'application/pdf'});
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = "solicitud_domiciliacion.pdf";
                    link.click();       
                }
                };

                xhr.send();
                this.active = false
                loading.close()
                
            } catch (error) {
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    title: 'Algo salio mal',
                    text: 'Por favor contacta al administrador'
                })
            }
      },
      onChangeNiveles () {
          this.listPrograma = []
          this.programa = ''
          this.getProgramas()
          this.openLoading()
      },
      openLoading() {
        const loading = this.$vs.loading({
          target: this.$refs.content
        })
        setTimeout(() => {
          loading.close()
        }, 3000)
      },
      checkByType (type, val) {
            switch (type) {
                case 'string':
                    if (val && val.constructor.name === 'String' && val.trim()) {
                        return true
                    }
                case 'number':
                    if (val && val.constructor.name === 'Number' && val > 0) {
                        return true
                    } 
                case 'date':
                  if (val && val.constructor.name === 'String' && val.trim()) {
                    const date = new Date(val)
                    if (Object.prototype.toString.call(date) === "[object Date]"){
                      if (!isNaN(date.getTime())){
                        return true
                      }
                    }
                  }
                case 'array':
                    if (Array.isArray(val) && val.length){
                        return true
                    }
            }
            return false
      },
      sanityForm () {
        let errorFields = []
        if (!this.checkByType ('number', this.programa)) {
          errorFields.push('programa')
        }  
        if (!this.checkByType ('number', this.nivel)) {
          errorFields.push('nivel')
        }  

        return errorFields
      },
        getColor(status){
            if (status && this.statusColores[status]){
                return `col-${this.statusColores[status]}`
            }else {
                return 'col-none'
            }
        },
        formatoDescuentos(val){
            if (val.tipo === 'porcentaje'){
                return val.monto + '%'
            }else{
                return this.$options.filters.currency(val.monto)
            }
        },
        getVencidoValue(value){
            if (value.tipo){
                switch (value.tipo) {
                    case 'servicio':
                        return 'Cargo por demanda'

                    case 'beca':
                        return value.saldo == 0 ? 'Aplicada' : 'Sin aplicar'
                            
                    default:
                    const hoy = new Date()
                    const vDate = new Date(value.fecha_vencimiento)
                    return vDate >= hoy ? 'En tiempo' : 'Vencido'
        
                }
            }

            return 'Sin definir'
        },
        getStatusCargo(value){
             if (value.tipo){
                switch (value.tipo) {
                    case 'servicio':
                        return 'No obligatorio'

                    case 'beca':
                        return value.saldo == 0 ? 'Aplicada' : 'Sin aplicar'
                            
                    default:
                        return value.saldo > 0 && value.saldo == value.monto ? 'Sin pagar' : value.parcializado == true && value.saldo == 0 ? 'Pagado totalmente por parcialización' : (value.saldo === 0 || value.parcializado && (value.saldo === 0)) ? 'Pagado totalmente' : value.saldo < 0 ? 'Sin aplicar' : value.saldo > 0 ? 'Sin pagar' : 'Sin definir'
        
                }
            }
            return 'Sin definir'
        },
        getPermisos(){
          this.rows.forEach(i => {
            if(i.pago_en_linea === true){
              this.pagoEnLinea = true
            }else{
              this.pagoEnLinea = false
            }
          })
          
          this.permisosGenerales = this.general && this.general.permisos
          // if(this.personaRol.tipoUserPrincipal == 'Personal central - TI'){
          //   if(this.permisos.includes('bloquear-pago-linea')){
          //     this.bloquearPago = false
          //   }
          // }
          const persona_rol = JSON.parse(this.personaRol)
          if(persona_rol.tipoUserPrincipal == 'alumno' || persona_rol.tipoUserPrincipal == 'familiar'){
            if(!this.permisosGenerales.includes('bloquear-pago-linea')){
              this.bloquearPago = true
            }
          }else{
            if(!this.permisos.includes('bloquear-pago-linea')){
              this.bloquearPago = true
            }
          }
        },
        async loadPaypalButtons(params){
          const { paramsReferencia } = params;
          const { institucion } = paramsReferencia;

          const { data } = await cobranza.getPaypalClient(institucion);
          
          if (!data?.enabled) {
            return data?.enabled;
          }

          this.onlinePaymentsMsg = 'Puedes realizar el pago a través de tu cuenta de PayPal o con tarjeta de débito o crédito en una sola exhibición.';
          let paypal;

          try {
              paypal = await loadScript({ clientId: data.clientId, currency: 'MXN', locale: 'es_MX' });
          } catch (error) {
              console.error("No se pudo cargar el script PayPal JS SDK", error);
          }

          if (paypal) {
            // Example function to show a result to the user. Your site's UI library can be used instead.
            function resultMessage(message) {
              const container = document.querySelector("#result-message");
              container.innerHTML = message;
            }

            try {
              const thisObject = this;
              await paypal.Buttons({
                async createOrder() {
                  try {
                    const responseRef = await cobranza.getReferenciaPayPal(paramsReferencia);
                    const referencia = responseRef?.data?.referencia;
                    const orderParams = {
                      institucion,
                      saldo: responseRef.data.saldo,
                      matricula: params.matricula,
                      referencia,
                    };
                    
                    const response = await fetch("/api/v2/paypal/orders", {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(orderParams),
                    });
                    
                    const orderData = await response.json();
                    
                    if (orderData.id) {
                      return orderData.id;
                    } else {
                      const errorDetail = orderData?.details?.[0];
                      const errorMessage = errorDetail
                      ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                      : JSON.stringify(orderData);
                      
                      throw new Error(errorMessage);
                    }
                  } catch (error) {
                    console.error(error);
                    resultMessage(`No se pudo iniciar PayPal Checkout...<br><br>${error}`);
                  }
                },
                async onApprove(data, actions) {
                  try {
                    const response = await fetch(`/api/v2/paypal/orders/${data.orderID}/process`, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify({ institucion }),
                    });
    
                    const orderData = await response.json(); 
                    const errorDetail = orderData?.details?.[0];
                    
                    if (orderData?.status !== 'COMPLETED') {
                      return actions.restart();
                    } else if (errorDetail) {
                      throw new Error(`${errorDetail.description} (${orderData.debug_id})`);
                    } else {
                      (orderData?.status == 'COMPLETED') ?
                      resultMessage(
                        `<span class="alert alert-success"> Transacción completada: ${orderData.message} </span>`
                      ) :
                      resultMessage(
                        `Transacción ${orderData.status}: ${orderData.message}`
                      )
                      
                      // Finalizar pago con notificación
                      thisObject.$emit('refreshTable');
                      thisObject.active = false;
                      thisObject.$vs.notification({
                        icon: '<i class="fas fa-check"></i>',
                        sticky: true,
                        duration: 'none',
                        color: 'success',
                        position: null,
                        title: orderData.message,
                      })
                      location.reload();
                    }
                  } catch (error) {
                    console.error(error);
                    resultMessage(`Lo sentimos, su transacción no pudo ser procesada.${error}`);
                  }
                },
                onError: function (err) {
                  resultMessage(err.message);
                }
              }).render("#paypal-button-container");
            } catch (error) {
              console.error("No se pudieron cargar los botones de Paypal", error);
            }
          }
          
          return data?.enabled;
        },
        async loadWire4Button(params){
          const { paramsReferencia } = params;
          const { institucion } = paramsReferencia;
          const { data } = await cobranza.getWire4Enabled(institucion);

          if (data?.enabled) {
            this.showWire4Button = true;
          }
        },
        async wire4Checkout() {

          this.loadingSpinner = true;

          let paramsReference = {           
            "persona" :this.personaId,
            "ciclo_escolar": this.cicloEscolar,
            "institucion": this.institucion,
            "cargos" : this.rows,
            "programa": this.programa
          }

          try {         
            const referenceResponse = await cobranza.getWire4Reference(paramsReference);
            const reference = referenceResponse?.data?.referencia;
            const clabeResponse = await cobranza.getWire4CLABE(paramsReference.persona, paramsReference.institucion);
            const clabe = clabeResponse?.data?.depositant_clabe;

            const paramsCheckout = {
              ...paramsReference,
              referencia: reference,
              clabe: clabe,
            };

            cobranza.postWire4Checkout(paramsCheckout);

            this.loadingSpinner = false;
            
          } catch (error) {
            if (error && error.referenceResponse && error.referenceResponse.data  && error.referenceResponse.data.descripcion ){
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Error al intentar generar SPEI',
                    text: error.referenceResponse.data.descripcion
                })
              }
          }
        },
    },
    watch: {
        value (val) {
            this.active = val
            this.getTypeCargo()
            this.getSeleccionCargo()
            this.getSeleccionDomiciliar()
            this.getPermisos()
            this.getDatosContacto()
            // this.getCuenta()
            // this.getInfoCuenta()
        },       
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        general(){
          this.permisosGenerales = this.general.permisos
        },
        pagar_paypal(){
          this.setLoaded();
        }
    }
}
</script>

<style lang="scss"  scoped >
.color-blue {
  background-color: #005aa3;
}

.dividerLine {
  width: 100%;
  border-bottom: 1px solid #ddd
}

.greyColor {
  color: gray
}

.greyOscuro {
  color: rgb(78, 78, 78);
  font-weight: bold;
}

.domicializar .vs-dialog{
    max-width: 95% !important;
}

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
    }
</style>

<style>
.vs-loading__load__text{
  font-size: 16px !important;
}
</style>